import { defineComponent as _defineComponent } from 'vue'
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { IBannerXAd } from 'JS/sponsored/sponsored-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'BannerX',
  props: {
    banner: null
  },
  setup(__props: any) {

const props = __props as {
	banner: IBannerXAd;
}



const gaDataAttributes = computed(() => createPromoDataAttributes({
	promoId: props.banner.ctaLink?.replace("https://www.farmandfleet.com", "") ?? 'EpsilonAdNoCTA',
	creativeSlot: `sponsored-banner_${props.banner.slot}`,
	creativeName: `sponsored-banner_${props.banner.adId}`,
	promoName: `${accessibleText.value}`
}));

const accessibleText = computed<string>(() => {
	const sponsored = "Sponsored ";
	if (props.banner.bannerImageAccessibleText === props.banner.ctaAccessibleText) {
		return sponsored + props.banner.bannerImageAccessibleText;
	} else {
		return sponsored + props.banner.bannerImageAccessibleText + " " + props.banner.ctaAccessibleText;
	}
});

function recordBannerImpression() {
	navigator.sendBeacon('/event/a/sponsored-ad-impression', JSON.stringify([props.banner.adId]));
}

function recordBannerClick(sendClickTracking: boolean) {
	if (sendClickTracking) {
		navigator.sendBeacon('/event/a/sponsored-ad-click', JSON.stringify(props.banner.adId));
	}
}


return { __sfc: true,props, gaDataAttributes, accessibleText, recordBannerImpression, recordBannerClick, VIntersectionObserver }
}

})